import React, { useState } from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { FileText, Download, Search, Calendar, ChevronDown } from 'lucide-react';

const FacultyManagementBoard2025 = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('all');

  const decisions = [
    {
      id: 1,
      number: 'FYKK/11.12.2025',
      date: '2025-12-11',
      title: 'Fakülte Yönetim Kurulu Kararları (11.12.2025) - 59',
      description: '11 Aralık 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Aralık',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/1/11.12.2025%20-%2059%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem%20(2).docx'
    },
    {
      id: 2,
      number: 'FYKK/04.12.2025',
      date: '2025-12-04',
      title: 'Fakülte Yönetim Kurulu Kararları (04.12.2025) - 57',
      description: '4 Aralık 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Aralık',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/1/04.12.2025%20-57%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 3,
      number: 'FYKK/27.11.2025',
      date: '2025-11-27',
      title: 'Fakülte Yönetim Kurulu Kararları (27.11.2025) - 56',
      description: '27 Kasım 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Kasım',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/1/27.11.2025%20-56%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem%20(1).docx'
    },
    {
      id: 4,
      number: 'FYKK/20.11.2025',
      date: '2025-11-20',
      title: 'Fakülte Yönetim Kurulu Kararları (20.11.2025) - 55',
      description: '20 Kasım 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Kasım',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/20.11.2025-55%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 5,
      number: 'FYKK/13.11.2025',
      date: '2025-11-13',
      title: 'Fakülte Yönetim Kurulu Kararları (13.11.2025) - 54',
      description: '13 Kasım 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Kasım',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/13.11.2025%20-%2054%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 6,
      number: 'FYKK/06.11.2025',
      date: '2025-11-06',
      title: 'Yönetim Kurulu Kararları (06.11.2025) - 53',
      description: '6 Kasım 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Kasım',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/06.11.2025%20-53%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 7,
      number: 'FYKK/23.10.2025',
      date: '2025-10-23',
      title: 'Yönetim Kurulu Kararları (23.10.2025) - 52',
      description: '23 Ekim 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Ekim',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/23.10.2025%20-52%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem%20(2).docx'
    },
    {
      id: 8,
      number: 'FYKK/16.10.2025',
      date: '2025-10-16',
      title: 'Fakülte Yönetim Kurulu Kararları (16.10.2025) - 50',
      description: '16 Ekim 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Ekim',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/16.10.2025%20-50%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 9,
      number: 'FYKK/09.10.2025',
      date: '2025-10-09',
      title: 'Yönetim Kurulu Kararları (09.10.2025) - 48',
      description: '9 Ekim 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Ekim',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/09.10.2025%20-48%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem%20(1).docx'
    },
    {
      id: 10,
      number: 'FYKK/02.10.2025',
      date: '2025-10-02',
      title: 'Fakülte Yönetim Kurulu Kararları (02.10.2025) - 45',
      description: '2 Ekim 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Ekim',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/02.10.2025%20-45%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 11,
      number: 'FYKK/25.09.2025',
      date: '2025-09-25',
      title: 'Fakülte Yönetim Kurulu Kararları (25.09.2025) - 43',
      description: '25 Eylül 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Eylül',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/25.09.2025%20-43%20Fak%C3%BClte%20%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 12,
      number: 'FYKK/18.09.2025',
      date: '2025-09-18',
      title: 'Fakülte Yönetim Kurulu Kararları (18.09.2025) - 42',
      description: '18 Eylül 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Eylül',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/18.09.2025%20-%2042%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem%20(1).docx'
    },
    {
      id: 13,
      number: 'FYKK/11.09.2025',
      date: '2025-09-11',
      title: 'Fakülte Yönetim Kurulu Kararları (11.09.2025) - 41',
      description: '11 Eylül 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Eylül',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/11.09.2025%20-41%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 14,
      number: 'FYKK/04.09.2025',
      date: '2025-09-04',
      title: 'Fakülte Yönetim Kurulu Kararları (04.09.2025) - 40',
      description: '4 Eylül 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Eylül',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/04.09.2025%20-40%20Fak%C3%BClte%20%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 15,
      number: 'FYKK/21.08.2025',
      date: '2025-08-21',
      title: 'Fakülte Yönetim Kurulu Kararları (21.08.2025) - 38',
      description: '21 Ağustos 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Ağustos',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/21.08.2025%20-38%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 16,
      number: 'FYKK/14.08.2025',
      date: '2025-08-14',
      title: 'Fakülte Yönetim Kurulu Kararları (14.08.2025) - 37',
      description: '14 Ağustos 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Ağustos',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/14.08.2025%20-%2037%20%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 17,
      number: 'FYKK/07.08.2025',
      date: '2025-08-07',
      title: 'Yönetim Kurulu Kararları (07.08.2025)',
      description: '7 Ağustos 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Ağustos',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/07.08.2025%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 18,
      number: 'FYKK/31.07.2025',
      date: '2025-07-31',
      title: 'Yönetim Kurulu Kararları (31.07.2025)',
      description: '31 Temmuz 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Temmuz',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/31.07.2025%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 19,
      number: 'FYKK/24.07.2025',
      date: '2025-07-24',
      title: 'Yönetim Kurulu Kararları (24.07.2025)',
      description: '24 Temmuz 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Temmuz',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/24.07.2025%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 20,
      number: 'FYKK/17.07.2025',
      date: '2025-07-17',
      title: 'Fakülte Yönetim Kurulu Kararları (17.07.2025) - 30',
      description: '17 Temmuz 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Temmuz',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/17.07.2025%20-%2030%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 21,
      number: 'FYKK/10.07.2025',
      date: '2025-07-10',
      title: 'Fakülte Yönetim Kurulu Kararları (10.07.2025) - 28',
      description: '10 Temmuz 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Temmuz',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/10.07.2025%20-%2028%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 22,
      number: 'FYKK/03.07.2025',
      date: '2025-07-03',
      title: 'Fakülte Yönetim Kurulu Kararları (03.07.2025) - 27',
      description: '3 Temmuz 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Temmuz',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/03.07.2025%20-%2027%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 23,
      number: 'FYKK/26.06.2025',
      date: '2025-06-26',
      title: 'Yönetim Kurulu Kararları (26.06.2025) - 25',
      description: '26 Haziran 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Haziran',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/26.06.2025%20-%2025%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 24,
      number: 'FYKK/19.06.2025',
      date: '2025-06-19',
      title: 'Fakülte Yönetim Kurulu Kararları (19.06.2025) - 24',
      description: '19 Haziran 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Haziran',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/19.06.2025%20-%2024%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 25,
      number: 'FYKK/12.06.2025',
      date: '2025-06-12',
      title: 'Fakülte Yönetim Kurulu Kararları (12.06.2025) - 23',
      description: '12 Haziran 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Haziran',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/12.06.2025%20-23%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 26,
      number: 'FYKK/29.05.2025',
      date: '2025-05-29',
      title: 'Fakülte Yönetim Kurulu Kararları (29.05.2025) - 22',
      description: '29 Mayıs 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Mayıs',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/29.05.2025%20-%2022%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20%20G%C3%BCndem%20(1).docx'
    },
    {
      id: 27,
      number: 'FYKK/22.05.2025',
      date: '2025-05-22',
      title: 'Fakülte Yönetim Kurulu Kararları (22.05.2025) - 21',
      description: '22 Mayıs 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Mayıs',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/22.05.2025%20-%2021%20Fak%C3%BClte%20%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem%20(1).docx'
    },
    {
      id: 28,
      number: 'FYKK/16.05.2025',
      date: '2025-05-16',
      title: 'Fakülte Yönetim Kurulu Kararları (16.05.2025) - 19',
      description: '16 Mayıs 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Mayıs',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/16.05.2025%20-%2019%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem%20(1).docx'
    },
    {
      id: 29,
      number: 'FYKK/15.05.2025',
      date: '2025-05-15',
      title: 'Fakülte Yönetim Kurulu Kararları (15.05.2025) - 19',
      description: '15 Mayıs 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Mayıs',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/15.05.2025%20-%2019%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 30,
      number: 'FYKK/08.05.2025',
      date: '2025-05-08',
      title: 'Fakülte Yönetim Kurulu Kararları (08.05.2025) - 18',
      description: '8 Mayıs 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Mayıs',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/08.05.2025%20-18%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 31,
      number: 'FYKK/30.04.2025',
      date: '2025-04-30',
      title: 'Fakülte Yönetim Kurulu Kararları (30.04.2025) - 17',
      description: '30 Nisan 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Nisan',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/30.04.2025-17%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndemi%20(1).docx'
    },
    {
      id: 32,
      number: 'FYKK/30.04.2025',
      date: '2025-04-30',
      title: 'Fakülte Yönetim Kurulu Kararları (30.04.2025)',
      description: '30 Nisan 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Nisan',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/30.04.2025%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndemi.docx'
    },
    {
      id: 33,
      number: 'FYKK/24.04.2025',
      date: '2025-04-24',
      title: 'Yönetim Kurulu Kararları (24.04.2025) - 16',
      description: '24 Nisan 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Nisan',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/24.04.2025%20-16%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 34,
      number: 'FYKK/17.04.2025',
      date: '2025-04-17',
      title: 'Fakülte Yönetim Kurulu Kararları (17.04.2025) - 15',
      description: '17 Nisan 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Nisan',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/17.04.2025%20-15%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem%202).docx'
    },
    {
      id: 35,
      number: 'FYKK/27.03.2025',
      date: '2025-03-27',
      title: 'Yönetim Kurulu Kararları (27.03.2025) - 14',
      description: '27 Mart 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Mart',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/27.03.2025%20-14%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 36,
      number: 'FYKK/20.03.2025',
      date: '2025-03-20',
      title: 'Fakülte Yönetim Kurulu Kararları (20.03.2025) - 13',
      description: '20 Mart 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Mart',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/20.03.2025%20-13%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 37,
      number: 'FYKK/13.03.2025',
      date: '2025-03-13',
      title: 'Fakülte Yönetim Kurulu Kararları (13.03.2025) - 12',
      description: '13 Mart 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Mart',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/13.03.2025%20-12%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.docx'
    },
    {
      id: 38,
      number: 'FYKK/06.03.2025',
      date: '2025-03-06',
      title: 'Fakülte Yönetim Kurulu Kararları (06.03.2025) - 10',
      description: '6 Mart 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Mart',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/06.03.2025%20%20-10%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem%20(1).docx'
    },
    {
      id: 39,
      number: 'FYKK/27.02.2025',
      date: '2025-02-27',
      title: 'Fakülte Yönetim Kurulu Kararları (27.02.2025) - 9',
      description: '27 Şubat 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Şubat',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/basliksiz_klasor/fakulte-yonetim-kurulu/27.02.2025%20-%209%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem%20(1).docx'
    },
    {
      id: 40,
      number: 'FYKK/20.02.2025',
      date: '2025-02-20',
      title: 'Fakülte Yönetim Kurulu Kararları (20.02.2025)',
      description: '20 Şubat 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Şubat',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/ykk/2025/20.02.2025%20-8%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.pdf'
    },
    {
      id: 41,
      number: 'FYKK/13.02.2025',
      date: '2025-02-13',
      title: 'Fakülte Yönetim Kurulu Kararları (13.02.2025)',
      description: '13 Şubat 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Şubat',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/ykk/2025/13.02.2025%20-7%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.pdf'
    },
    {
      id: 42,
      number: 'FYKK/06.02.2025',
      date: '2025-02-06',
      title: 'Fakülte Yönetim Kurulu Kararları (06.02.2025)',
      description: '6 Şubat 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Şubat',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/ykk/2025/06.02.2025%20-5%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem%20(1).pdf'
    },
    {
      id: 43,
      number: 'FYKK/30.01.2025',
      date: '2025-01-30',
      title: 'Fakülte Yönetim Kurulu Kararları (30.01.2025)',
      description: '30 Ocak 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Ocak',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/ykk/2025/30.01.2025%20-%204%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20G%C3%BCndem.pdf'
    },
    {
      id: 44,
      number: 'FYKK/23.01.2025',
      date: '2025-01-23',
      title: 'Fakülte Yönetim Kurulu Kararları (23.01.2025)',
      description: '23 Ocak 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Ocak',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/ykk/2025/23.01.2025%20-%203%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20%20G%C3%BCndem.pdf'
    },
    {
      id: 45,
      number: 'FYKK/16.01.2025',
      date: '2025-01-16',
      title: 'Fakülte Yönetim Kurulu Kararları (16.01.2025)',
      description: '16 Ocak 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Ocak',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/ykk/2025/16.01.2025%20-%202%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20%20G%C3%BCndem.pdf'
    },
    {
      id: 46,
      number: 'FYKK/09.01.2025',
      date: '2025-01-09',
      title: 'Fakülte Yönetim Kurulu Kararları (09.01.2025)',
      description: '9 Ocak 2025 tarihli Fakülte Yönetim Kurulu toplantısında alınan kararlar.',
      month: 'Ocak',
      fileUrl: 'https://fs.hacettepe.edu.tr/fenyeni/ykk/09.01.2025%20Fak%C3%BClte%20Y%C3%B6netim%20Kurulu%20-1%20%20G%C3%BCndem.pdf'
    }
  ];

  const months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 
                  'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

  const filteredDecisions = decisions.filter(decision => {
    const matchesSearch = decision.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         decision.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         decision.number.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesMonth = selectedMonth === 'all' || decision.month === selectedMonth;
    return matchesSearch && matchesMonth;
  });

  return (
    <PageTemplate 
      title="2025 Yılı Fakülte Yönetim Kurulu Kararları"
      breadcrumb={[
        { label: 'Anasayfa', url: '/' },
        { label: 'Fakülte Kararları', url: '/kararlar' },
        { label: 'Fakülte Yönetim Kurulu Kararları', url: '/kararlar/fakulte-yonetim' },
        { label: '2025' }
      ]}
    >
      <div className="max-w-6xl mx-auto">
        {/* Başlık */}
        <div className="bg-gradient-to-br from-green-50 to-emerald-100 rounded-xl p-8 mb-8">
          <div className="flex items-center mb-4">
            <FileText className="w-8 h-8 text-green-600 mr-3" />
            <h2 className="text-2xl font-bold text-gray-800">2025 Yılı Fakülte Yönetim Kurulu Kararları</h2>
          </div>
          <p className="text-gray-700">
            2025 yılında alınan toplam {decisions.length} adet fakülte yönetim kurulu kararını inceleyebilirsiniz.
          </p>
        </div>

        {/* Filtreler */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Arama */}
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Karar ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
              />
            </div>

            {/* Ay Filtresi */}
            <div className="relative">
              <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all appearance-none bg-white"
              >
                <option value="all">Tüm Aylar</option>
                {months.map(month => (
                  <option key={month} value={month}>{month}</option>
                ))}
              </select>
              <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 pointer-events-none" />
            </div>
          </div>
        </div>

        {/* Kararlar Listesi */}
        <div className="space-y-6">
          {filteredDecisions.map((decision) => (
            <div 
              key={decision.id}
              className="bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-shadow p-6"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-3 mb-3">
                    <span className="bg-green-100 text-green-800 text-sm font-medium px-3 py-1 rounded-full">
                      Karar No: {decision.number}
                    </span>
                    <span className="text-gray-500 text-sm">{decision.date}</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    {decision.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    {decision.description}
                  </p>
                </div>
                <div className="ml-6">
                  <a 
                    href={decision.fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center space-x-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg transition-colors"
                  >
                    <Download className="w-4 h-4" />
                    <span>İndir</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Sonuç bulunamadı */}
        {filteredDecisions.length === 0 && (
          <div className="text-center py-12">
            <FileText className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-600 mb-2">Karar bulunamadı</h3>
            <p className="text-gray-500">
              Arama kriterlerinize uygun karar bulunmamaktadır. Lütfen farklı terimler deneyin.
            </p>
          </div>
        )}
      </div>
    </PageTemplate>
  );
};

export default FacultyManagementBoard2025; 